import { render, staticRenderFns } from "./modal-component.vue?vue&type=template&id=67ef50e4"
import script from "./modal-component.ts?vue&type=script&lang=ts&external"
export * from "./modal-component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports